import Image, { ImageProps } from 'next/image';
import React from 'react';

interface OptimizedImageProps extends Omit<ImageProps, 'alt'> {
    alt: string;
    className?: string;
    containerClassName?: string;
    priority?: boolean;
    sizes?: string;
}

/**
 * Elite Optimized Image Component
 * Automatically serves AVIF/WebP, enforces lazy loading, and provides responsive sizes.
 */
const OptimizedImage: React.FC<OptimizedImageProps> = ({
    src,
    alt,
    width,
    height,
    fill,
    className = "",
    containerClassName = "",
    priority = false,
    sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw",
    ...props
}) => {
    return (
        <div className={`relative overflow-hidden ${fill ? 'h-full w-full' : ''} ${containerClassName}`}>
            <Image
                src={src}
                alt={alt}
                width={width}
                height={height}
                fill={fill}
                priority={priority}
                quality={85}
                loading={priority ? undefined : "lazy"}
                // Responsive sizes attribute is CRITICAL for SEO and Performance
                // It helps the browser pick the right image size before the page layout is fully calculated
                sizes={sizes}
                className={`object-cover duration-700 ease-in-out transition-all ${className}`}
                {...props}
            />
        </div>
    );
};

export default OptimizedImage;
